export default {"src":"/_next/static/media/grow.2d59454e.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};